/**
 * 고른 층 이름을 화면 전체에 — 레이아웃(`AdminLayout`)이 사업장 구성을 한 번 읽어 두고, [사업장·위치] 에서 바꾸면
 * 저장 직후 그 값으로 갈아 끼운다(메뉴 부제·모니터링이 새로 고치지 않아도 같은 말을 쓰게).
 */
import { createContext, useContext } from 'react';
import { DEFAULT_SITE_LABELS, type SiteLabels } from '../siteLabels.js';

export interface SiteLabelsState {
  labels: SiteLabels;
  /** 서버에서 새로 받은 값(빈 칸은 기본)으로 바꾼다. */
  update: (labels: Partial<SiteLabels> | null | undefined) => void;
}

export const SiteLabelsContext = createContext<SiteLabelsState>({ labels: DEFAULT_SITE_LABELS, update: () => {} });

export const useSiteLabels = (): SiteLabels => useContext(SiteLabelsContext).labels;
export const useUpdateSiteLabels = (): SiteLabelsState['update'] => useContext(SiteLabelsContext).update;
